export default {
    top_menu: [
        {name:'Lucrul principal',    id:0},
        {name:'spectacol Afaceri', id:1},
        {name:'Gătit',  id:2},
        {name:'Politică',   id:3},
        {name:'+18',  id:4},
        {name:'Societate',   id:5},
        {name:'Sănătate',   id:6},
    ],
    read_other: 'Citeste mai mult',
    read_more:  'Mai multe detalii',
    not_found:  'Nimic gasit',
    read_also:  'Citește și',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Toate drepturile rezervate.',
    subscribe: 'Aboneaza-te la',

    thank_order: 'MULTUMESC PENTRU COMANDA DUMNEAVOASTRĂ',
    specialist_contact: 'Specialistul nostru vă va contacta în curând, așteptați apelul nostru.',
    attention: 'Reduceri de la parteneri:',
    hurry: 'Grăbește-te, timpul de activare a reducerii este limitat! Ai la dispoziție doar <span id="time" class="time">30:00</span> minute pentru a alege unul dintre aceste produse unice:',

    hour_ago1: "Acum o ora",
    hour_ago2: "ore în urmă",
    hour_ago3: "ore în urmă",
    new_publications: "ore Publicații noi Înapoi",
    read: "Citit",
    today_at: "Astăzi la",
    author_names: ['Mihai Treistariu','Horia Roman','Corneliu Porumboiu'],
    main_news: "Știri principale",
    leave_already: "Pleci deja? Așteptați, am actualizat știrile pentru dvs.",
    already_shared: "deja partajat"

}